import { User } from '@src/entities/User/ui/components/User';
import { Button as ButtonComponent } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React, { useState } from 'react';

import { Modal } from '../Modal';

/**
 * Button: Create
 *
 * This button is used to create a new entity.
 *
 * @param children
 * @param refetch
 * @param setFocusedEntity
 * @returns {Element}
 * @constructor
 */
export function Button({ children, refetch = () => {}, setFocusedEntity = () => {} }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ErrorHandler location="src/features/CommonCriteria/Create/components/Button/Button.jsx">
      <User.Capability attributes={['create']} resource="Admin:CommonCriteria">
        <ButtonComponent
          before={<IconSymbol icon="add" />}
          css={{
            marginLeft: 'var(--abyss-space-md)',
          }}
          onClick={() => {
            setIsOpen(true);
          }}
          size="$sm"
          variant="outline"
        >
          {children}
        </ButtonComponent>
      </User.Capability>
      {isOpen && <Modal isOpen={isOpen} refetch={refetch} setFocusedEntity={setFocusedEntity} setIsOpen={setIsOpen} />}
    </ErrorHandler>
  );
}
